// Fake store 会被单独打包运行，此模块只保留纯数据与纯函数，不引入应用依赖。

/** 账号绑定的联系目标：基础资料的邮箱/手机号与安全设置的备用邮箱。 */
export type BindingChannel = 'email' | 'phone' | 'recoveryEmail';

export const bindingChannels: BindingChannel[] = ['email', 'phone', 'recoveryEmail'];

/**
 * 演示流程的固定参数。Fake 不发送真实短信或邮件，验证码固定为 `code`，
 * 通过后仅记录“演示已验证”，不代表真实身份验证。
 */
export const bindingDemo = {
  code: '123456',
  cooldownSeconds: 60,
  codeTtlSeconds: 300,
  maxAttempts: 5,
} as const;

export const bindingErrorCodes = [
  'invalid_target',
  'cooldown',
  'no_challenge',
  'target_mismatch',
  'code_expired',
  'invalid_code',
  'challenge_locked',
] as const;

export type BindingErrorCode = (typeof bindingErrorCodes)[number];

const bindingErrorCodeSet = new Set<string>(bindingErrorCodes);

export function isBindingErrorCode(value: unknown): value is BindingErrorCode {
  return typeof value === 'string' && bindingErrorCodeSet.has(value);
}

function maskEmail(value: string) {
  const at = value.lastIndexOf('@');
  if (at <= 0) return value ? '***' : '';
  return `${value.slice(0, 1)}***${value.slice(at)}`;
}

function maskPhone(value: string) {
  const digits = value.replace(/\D/g, '');
  if (digits.length < 4) return value ? '***' : '';
  return `${digits.length >= 11 ? digits.slice(0, 3) : ''}****${digits.slice(-4)}`;
}

export function maskBindingValue(channel: BindingChannel, value: string) {
  if (!value) return '';
  return channel === 'phone' ? maskPhone(value) : maskEmail(value);
}

export type ContactBinding = {
  channel: BindingChannel;
  maskedValue: string;
  /** 仅表示演示流程中的验证状态。 */
  verified: boolean;
};
export type BindingCodeRequest = { channel: BindingChannel; target: string };
export type BindingCodeIssued = {
  channel: BindingChannel;
  maskedTarget: string;
  expiresInSeconds: number;
  cooldownSeconds: number;
  attemptsLeft: number;
};
export type BindingVerifyRequest = BindingCodeRequest & { code: string };
export type BindingVerifyResult = { binding: ContactBinding; profileVersion: number };
